import Collection from './Collection'
import { Routes, Route, Link, Navigate, NavLink, useLocation } from 'react-router-dom'
import Payment from './Payment'
import Due from './Due'

const Reports = () => {
    return (
        <div className="container-fluid px-0 h-100">
            <div className="row gap-3 gap-md-0 p-3">
                <div className="col-12 col-md-3 col-lg-2">
                    <div className="card border shadow-sm rounded-3 overflow-hidden sticky-md-top">
                        <div className="card-body p-0">
                            <div className="px-4 py-3 border-bottom bg-light d-none d-md-block">
                                <h5 className="fw-bold mb-0 text-dark">Reports</h5>
                            </div>
                            <div className="p-2 d-flex flex-row flex-md-column gap-2 flex-nowrap overflow-auto scrollbar-hidden" >
                                <NavLink
                                    className={({ isActive }) => `text-decoration-none d-flex align-items-center gap-2 rounded-2 py-2 px-3 ${isActive ? 'bg-app text-white shadow-sm' : 'text-app'}`}
                                    to="collection"
                                >
                                    <i className="bi bi-wallet2"></i>
                                    <span>Collection</span>
                                </NavLink>
                                <NavLink
                                    className="text-decoration-none d-flex align-items-center gap-2 rounded-2 py-2 px-3 text-muted opacity-50 pe-none"
                                    to="payment"
                                >
                                    <i className="bi bi-cash-stack"></i>
                                    <span>Payment</span>
                                </NavLink>
                                {/* <NavLink
                                    className={({ isActive }) => `text-decoration-none d-flex align-items-center gap-2 rounded-2 py-2 px-3 ${isActive ? 'bg-app text-white shadow-sm' : 'text-app'}`}
                                    to="due"
                                >
                                    <i className="bi bi-clock-history"></i>
                                    <span>Due</span>
                                </NavLink> */}
                            </div>
                        </div>
                    </div>
                </div>

                {/* Content Area */}
                <div className="col-12 col-md-9 col-lg-10">
                    <div className="d-flex flex-column overflow-auto scrollbar-hidden reportRightSide pe-md-3">
                        <Routes>
                            <Route path="/" element={<Navigate to="collection" replace />} />
                            <Route path="collection" element={<Collection />} />
                            <Route path="payment" element={<Payment />} />
                            {/* <Route path="due" element={<Due />} /> */}
                        </Routes>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default Reports;